import { render, staticRenderFns } from "./CoTicketViewer.vue?vue&type=template&id=130bf9e6&scoped=true&"
import script from "./CoTicketViewer.vue?vue&type=script&lang=ts&"
export * from "./CoTicketViewer.vue?vue&type=script&lang=ts&"
import style0 from "./CoTicketViewer.vue?vue&type=style&index=0&id=130bf9e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bf9e6",
  null
  
)

export default component.exports